<template>
	<div class="vip-promotion">
		<div style="position: absolute; left: 20px; top: 20px; z-index: 99999999;">
			<van-icon color="#ffffff" size="20" name="arrow-left" style="text-shadow: 2px 2px 4px #000;" @click="navBack" />
		</div>
<!--		<div class="grid-row">-->
<!--			<img src="@/assets/vip-promotion/promotion_01.jpg" style="width: 100%" alt=""/>-->
<!--		</div>-->
		<div class="video-wrap">
			<div id="odiv" ref="odiv" class="video-box">
				<a id="play" ref="play" href="javascript:;"></a>
			</div>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_02.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_03.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_04.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_05.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_06.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_07.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_08.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_09.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_10.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_11.jpg" style="width: 100%" alt=""/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_01.jpg" style="width: 100%" alt="" @click="openWxPayService"/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_02.jpg" style="width: 100%" alt="" @click="openWxCustomerService"/>
		</div>
		<div class="grid-row">
			<img src="@/assets/vip-promotion/promotion_12_03.jpg" style="width: 100%" alt="" />
		</div>
	</div>
</template>

<script>
export default {
	name: "vippromotion",
	mounted() {
		this.insertCCPlayer();
	},
	methods: {
		// 打开在线客服
		openWxCustomerService() {
			const screen = navigator.userAgent;
			const isAndroid = screen.indexOf('Android') > -1 || screen.indexOf('Adr') > -1;
			const isIos = !!screen.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (isAndroid) {
				if (!window.Android_JS) {
					this.$utils.dialog.alert("安卓方法Android_JS不存在");
					return;
				}
				if (!window.Android_JS.openWxCustomerService) {
					this.$utils.dialog.alert("请您升级训美在线至最新版本");
					return;
				}
				window.Android_JS.openWxCustomerService();
			}
			if (isIos) {
				window.webkit.messageHandlers.openWxCustomerService.postMessage(null);
			}
		},
		// 调起微信支付
		openWxPayService() {
			const screen = navigator.userAgent;
			const isAndroid = screen.indexOf('Android') > -1 || screen.indexOf('Adr') > -1;
			const isIos = !!screen.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
			if (isAndroid) {
				if (!window.Android_JS) {
					this.$utils.dialog.alert("安卓方法Android_JS不存在");
					return;
				}
				if (!window.Android_JS.openWxPayService) {
					this.$utils.dialog.alert("请您升级训美在线至最新版本");
					return;
				}
				window.Android_JS.openWxPayService();
			}
			if (isIos) {
				window.webkit.messageHandlers.openWxPayService.postMessage(null);
			}
		},
		// 点击回退
		navBack() {
			if (this.$route.query.fromPage === 'AD') {
				this.$router.back();
			} else {
				// 兼容广东交信投使用原生开发的app,app定义closeWindows()方法
				if (this.$store.state.cache.screen.isAndroid) {
					console.log("调用安卓方法Android_JS", window)
					if (!window.Android_JS) {
						this.$utils.dialog.alert("安卓方法Android_JS不存在");
						return;
					}
					if (!window.Android_JS.closeWindows) {
						this.$utils.dialog.alert("安卓方法closeWindows不存在");
						return;
					}
					window.Android_JS.closeWindows();
				}
				if (this.$store.state.cache.screen.isIos) {
					console.log("调用ios方法")
					window.webkit.messageHandlers.closeWindows.postMessage(null);
				}
			}
		},
		insertCCPlayer() {
			const script = document.createElement("script");
			script.src =
				"https://p.bokecc.com/player?vid=768182DCB606A8250498CE5AAF1F53F5&siteid=D9CDA78D56C216BD&autoStart=false&width=100%25&height=100%25&playerid=&playertype=&mediatype=1&customerId=";
			script.type = "text/javascript";

			script.onload = () => {
				const playEl = this.$refs.play;
				const ua = navigator.userAgent;
				playEl.style.display = "none";

				if (ua.indexOf("Android") !== -1) {
					setTimeout(() => {
						const video = this.$refs.odiv.getElementsByTagName("video")[0];
						if (!video) return;

						video.addEventListener("playing", () => {
							playEl.style.display = "none";
							if (ua.indexOf("Android 2") !== -1) {
								playEl.style.display = "block";
							}
						});
					}, 1000);
				}
			};

			this.$refs.odiv.insertBefore(script, this.$refs.play);
		},
	}
}
</script>

<style scoped lang="less">
.video-wrap {
	position: relative;
	width: 100%;
	padding-top: 56.25%; /* 16:9 */
}

.video-box {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}
/* 播放按钮 */
#play {
	width: 80px;
	height: 80px;
	background: #333;
	border-radius: 40px;
	box-shadow: 0 0 8px 3px #FFF;
	position: absolute;
	top: 50%;
	left: 50%;
	margin: -40px 0 0 -40px;
	z-index: 99999;
	-webkit-tap-highlight-color: transparent;
	opacity: 0.8;
}

#play:after {
	display: block;
	content: '';
	width: 0;
	height: 0;
	overflow: hidden;
	position: absolute;
	top: 20px;
	left: 25px;
	border-left: 38px solid #FFF;
	border-top: 20px solid rgba(0, 0, 0, 0);
	border-bottom: 20px solid rgba(0, 0, 0, 0);
	cursor: pointer;
}

.vip-promotion {
	font-size: 0;
	margin: 0;
	padding: 0;
	.grid-row {
		font-size: 0;
	}
}
</style>
